




























import Vue, { PropType } from 'vue'

type OuiNonSO = 'O' | 'N' | null

export default Vue.extend({
  name: 'StrictChooser',
  props: {
    // ⚠️ Ajout de la prop `value` pour supporter v-model (Vue 2)
    value: {
      type: String as PropType<OuiNonSO>,
      default: null
    },
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    modelValue: {
      get (): OuiNonSO {
        return this.value
      },
      set (val: OuiNonSO) {
        this.$emit('input', val)
      }
    }
  }
})
